import React from "react";
import { EnerleftMark } from "./Nav";

export default function Footer() {
    return (
        <footer className="lp-footer">
            <div className="lp-footer-top">
                <EnerleftMark size={20} />
                <div className="lp-footer-tag">ENERLEFT · Full services · Bari</div>
            </div>
            <div className="lp-footer-legal">
                ENERLEFT SRL · Via Orfeo Mazzitelli 140, 70124 Bari (BA) · P.IVA/C.F. 09162550728 · PEC enerleftsrl@pec.it · REA BA-675922 · Capitale sociale € 10.000,00 i.v.
            </div>
        </footer>
    );
}
